'use strict';

angular.module('portal.services')
    .controller('PortalService', ['$scope', '$stateParams', 'Services', '$state', function ($scope, $stateParams, Services, $state) {
        $scope.masterService = $stateParams.service;
        $scope.service = $stateParams.service;
        $scope.serviceID = $stateParams.id;
        $scope.serviceLoading = true;

        $scope.setMasterService = function (service) {
            $scope.masterService = service;
            $scope.service = angular.copy($scope.masterService);
        }

        $scope.resetService = function () {
            if ($scope.masterService == null) {
                $scope.masterService = {};
            }
            $scope.service = angular.copy($scope.masterService);
        }

        $scope.getService = function () {
            $scope.serviceLoading = true;

            Services.getByID($stateParams.id).then(function (service) {
                $scope.serviceLoading = false;
                $scope.setMasterService(service);
            })
        }
        
        if ($stateParams.id != null) {
            $scope.getService();
        }
        else {
            $state.go('portal.menus.denied');
        }
    }])
;